var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[(_vm.profileLink)?_c('router-link',{staticClass:"no-default-link-style",attrs:{"to":{ name: 'HorseProfilePage', params: { horseId: _vm.horse.id } },"target":_vm.linkTarget}},[_vm._v("\n      "+_vm._s(_vm.displayName)+"\n    ")]):_c('span',[_vm._v(_vm._s(_vm.displayName))]),_vm._v(" "),(_vm.horse.ponyType)?[_vm._v("\n      |\n      "),_c('AppShowHorsePonyStatus',{attrs:{"horse":_vm.horse,"start-date":_vm.startDateForPonyMeasurementValidate}})]:_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.showRegistryNumber))]),_vm._v(" "),_c('span',[_vm._v(" |\n      "+_vm._s(_vm.horse.ageForSeason
          ? _vm.horse.ageForSeason +
            _vm.$t(
              "horses:appShowHorse.age.suffix",
              "y.",
              "Suffix to show after horse age"
            )
          : ""))])],2),_vm._v(" "),_c('div',[_vm._t("appendHorseDetails",null,{"horse":_vm.horse})],2),_vm._v(" "),_c('div',{staticClass:"muted--text",domProps:{"innerHTML":_vm._s(_vm.displayDetails)}}),_vm._v(" "),(_vm.detailsType == 'full')?_c('div',[_vm._v("\n    "+_vm._s(_vm.$t(
        "horses:appShowHorse.Licence.field.label",
        "Licence:",
        "Licence field label for horse"
      ))+"\n    "),_c('AppValidationAlert',{attrs:{"check-valid":_vm.horse.currentSeasonLicenceValid,"valid":_vm.$t(
          'horses:appshow.licence.valid.label',
          'Valid',
          'Label for valid yearly licence status'
        ),"invalid":_vm.$t(
          'horses:appshow.licence.invalid.label',
          'Not valid',
          'Label for invalid yearly licence status'
        )}}),_vm._v(" "),_c('div',[_vm._v("\n      "+_vm._s(_vm.$t(
          "horses:appShowHorse.vaccination.field.label",
          "Vaccination:",
          "Vaccination field label for horse"
        ))+"\n\n      "),_c('AppShowHorseVaccinationStatus',{attrs:{"horse":_vm.horse,"check-date":_vm.vaccinationCheckDate}}),_vm._v(" "),_vm._t("showVaccinations",null,{"horse":_vm.horse})],2)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }